import { useTranslation } from 'react-i18next';

import { RightNewCases, RightNewDistributions } from './';

export const SidebarRight = () => {
  const { t } = useTranslation();

  return (
    <aside className="page-news-sidebar">
      {/* <RightNewDistributions /> */}
      <RightNewCases />
      <a 
        className="btn-partners"
        href="/referral"
        target="_blank"
        rel="nofollow"
      >
        <div className="icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.5 4.17219H10.5V9.49153H19.5V4.17219H16.0922L16.0949 4.16725C16.2874 3.81486 16.5 3.42563 16.5 2.99765C16.5 1.62736 15.2735 0.5 13.893 0.5C11.501 0.5 10.001 2.99753 10.001 2.99753C10.001 2.99753 8.50098 0.5 6.10695 0.5C4.72652 0.5 3.5 1.62736 3.5 2.99765C3.5 3.42563 3.71261 3.81486 3.90511 4.16725L3.9078 4.17219H0.5V9.49153H9.5V4.17219ZM9.5 4.17219L6.10672 4.17226C5.44778 4.17226 4.5 3.74388 4.5 2.99765C4.5 2.25141 5 1.49906 6.10695 1.49906C7.29364 1.49906 9.17253 3.00361 9.5 4.17219ZM10.5 4.17219L13.8933 4.17226C14.5522 4.17226 15.5 3.74388 15.5 2.99765C15.5 2.25141 15 1.49906 13.893 1.49906C12.7064 1.49906 10.8275 3.00361 10.5 4.17219Z"
              fill="white"
            ></path>
            <path d="M9.5 19.5V10.4906H1.3257V19.5H9.5Z" fill="white"></path>
            <path d="M10.5 19.5V10.4906H18.6743V19.5H10.5Z" fill="white"></path>
          </svg>
        </div>
        {t('btn-partners a')}
      </a>
    </aside>
  );
};
